// extracted by mini-css-extract-plugin
export default {"myModal":"modal_myModal__D9f2-","myModalContent":"modal_myModalContent__abExs","active":"modal_active__sFeOx"};